module.exports = __webpack_public_path__ + "static/media/ball_2_2.82f43a83.mp3";